module.exports = __webpack_public_path__ + "img/transporter-2.5c7e00ac.svg";